import { createFileRoute } from "@tanstack/react-router";

import TransactionsFileImport from "@/features/transactions/company/transactions-file-import";

export const Route = createFileRoute(
  "/_authenticated/$company/unternehmen/_fullscreen/transaktionen/importieren",
)({
  component: TransactionsImportPage,
});

function TransactionsImportPage() {
  return <TransactionsFileImport />;
}
